// src/pages/GuidePage.jsx
import React from "react";

const GuidePage = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white md:rounded-3xl tex">
      <h1 className="text-2xl font-bold mb-6 text-center">
        Khuddam Chanda App Guide
      </h1>

      {/* Section 1: Register & Login */}
      <h1 className="text-xl font-semibold mb-3">Register & Login</h1>
      <ol className="list-decimal list-inside space-y-9 mb-8">
        <li>
          Open the <strong>Login screen</strong>:
          <img
            src="/images/login-screen.png"
            alt="Login Screen"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>
          If you don’t have an account, click <strong>Sign Up</strong>:
          <img
            src="/images/register-screen.png"
            alt="Register Screen"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>
          After registering, you will receive{" "}
          <strong>temporary credentials via email</strong>:
          <img
            src="/images/temp-credentials-email.png"
            alt="Temporary Credentials Email"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>Login with your email & temporary password.</li>
        <li>
          You’ll be prompted to <strong>set a new password</strong>:
          <img
            src="/images/set-new-password.png"
            alt="Set New Password"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>
          After success, you’ll be greeted with the <strong>Dashboard</strong>:
          <img
            src="/images/dashboard-screen.png"
            alt="Dashboard Screen"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
      </ol>

      {/* Section 2: Pay Chanda */}
      <h2 className="text-xl font-semibold mb-3">Pay Chanda</h2>
      <ol className="list-decimal list-inside space-y-4">
        <li>
          Go to <strong>Pay Chanda</strong>:
          <img
            src="/images/pay-chanda-screen.png"
            alt="Pay Chanda Screen"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>
          Choose <strong>Based on Salary</strong> or{" "}
          <strong>Manual Input</strong>.
        </li>
        <li>
          If <strong>Based on Salary</strong> → Membership & Ijtima
          auto-calculated.
        </li>
        <li>
          If <strong>Manual Input</strong> → Enter your own values.
        </li>
        <li>
          Select a <strong>Payment Method</strong> (FPX or DuitNow QR):
          <img
            src="/images/pay-duitnow-qr.png"
            alt="DuitNow QR Payment"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>Proceed with Bank / eWallet payment.</li>
        <li>
          ⚠️ <strong>Warning (DuitNow QR)</strong>: Sometimes QR may fail to
          generate:
          <img
            src="/images/error-generate-qr.png"
            alt="QR Error"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
          <br />→ Wait <strong>5 minutes</strong> & retry. → Or reopen payment
          at <em>Dashboard → transaction with INITIATED → Pay Now</em>:
          <img
            src="/images/payment-pending.png"
            alt="Payment Pending"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>⏱ You have 20 minutes before the payment expires.</li>
        <li>
          After success, you’ll be redirected to <strong>Receipt screen</strong>
          :
          <img
            src="/images/receipt-screen.png"
            alt="Receipt Screen"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
        <li>
          You can download your <strong>Chanda Receipt</strong> from Dashboard →
          Transactions:
          <img
            src="/images/chanda-receipt-screen.png"
            alt="Chanda Receipt Screen"
            className="mt-2 rounded-xl shadow mx-auto mt-5"
          />
        </li>
      </ol>

      <p className="text-gray-600 mt-6 text-center text-sm">
        For assistance, contact us at{" "}
        <a
          href="mailto:support.chanda@khuddammalaysia.com"
          className="underline text-blue-500"
        >
          support.chanda@khuddammalaysia.com
        </a>
      </p>
    </div>
  );
};

export default GuidePage;
